import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

/**
 * Obtiene la configuración de generación de SKU para un cliente
 * @param {string} clientId - ID del cliente
 * @returns {Promise<Object>} - Respuesta con la configuración de SKU
 */
export const getSKUConfig = async (clientId) => {
  try {
    // Enviar evento para mostrar indicador de carga
    const event = new CustomEvent('skuConfigLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axios.get(
      `${API_URL}/workflows/p2p/${clientId}/sku-config`
    );
    
    // Enviar evento para ocultar indicador de carga
    const endEvent = new CustomEvent('skuConfigLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar indicador de carga en caso de error
    const endEvent = new CustomEvent('skuConfigLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener configuración de SKU:", error.response?.data || error);
    throw error;
  }
};

/**
 * Actualiza la configuración de generación de SKU para un cliente
 * @param {string} clientId - ID del cliente
 * @param {Object} configData - Datos de configuración de SKU
 * @returns {Promise<Object>} - Respuesta con la configuración actualizada
 */
export const updateSKUConfig = async (clientId, configData) => {
  try {
    // Enviar evento para mostrar indicador de carga
    const event = new CustomEvent('skuConfigUpdating', { detail: true });
    window.dispatchEvent(event);

    const response = await axios.put(
      `${API_URL}/workflows/p2p/${clientId}/sku-config`,
      configData
    );
    
    // Enviar evento para ocultar indicador de carga
    const endEvent = new CustomEvent('skuConfigUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar indicador de carga en caso de error
    const endEvent = new CustomEvent('skuConfigUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al actualizar configuración de SKU:", error.response?.data || error);
    throw error;
  }
};

/**
 * Genera un nuevo SKU para un item de inventario
 * @param {string} clientId - ID del cliente
 * @param {Object} itemData - Datos del item para generar el SKU
 * @returns {Promise<Object>} - Respuesta con el SKU generado
 */
export const generateSKU = async (clientId, itemData) => {
  try {
    // Enviar evento para mostrar indicador de carga
    const event = new CustomEvent('skuGenerating', { detail: true });
    window.dispatchEvent(event);

    const response = await axios.post(
      `${API_URL}/workflows/p2p/${clientId}/inventory/generate-sku`,
      itemData
    );
    
    // Enviar evento para ocultar indicador de carga
    const endEvent = new CustomEvent('skuGenerating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar indicador de carga en caso de error
    const endEvent = new CustomEvent('skuGenerating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al generar SKU:", error.response?.data || error);
    throw error;
  }
};

